import type { SendLogParams } from "@haskoning/usage-monitor-client";
import type { Ref } from "vue";

import type { ApiEntry } from "@/services/api-inventory/apiInventory.types";
import type { ExcelFunction } from "@/services/custom-functions/customFunction.types";
import { usageMonitor } from "@/services/usage-monitor/usageMonitor";

const THROTTLE_WINDOW_MS = 5 * 60 * 1000;

export function createCustomFunctionUsageMonitor(apiEntries: Ref<Map<string, ApiEntry>>) {
  const loggedFunctions = new Map<string, number>();

  function buildUsageMonitorLog(func: ExcelFunction): SendLogParams {
    const apiEntry = Array.from(apiEntries.value.values()).find((entry) => func.url.startsWith(entry.url));
    const endpointPath = new URL(func.url).pathname;
    const apiName =
      typeof apiEntry?.item === "object" ? apiEntry.item.name : (apiEntry?.schemaInfo?.title ?? "Unknown API");

    return {
      projectCode: func.id,
      projectName: apiName,
      action: `${String(func.method).toUpperCase()} ${endpointPath}`,
      applicationName: `Equation Platform - Excel Client - ${apiName}`,
    };
  }

  function logFunctionUsage(func: ExcelFunction): void {
    const now = Date.now();
    const lastLogged = loggedFunctions.get(func.id) || 0;

    if (now - lastLogged <= THROTTLE_WINDOW_MS) {
      return;
    }

    loggedFunctions.set(func.id, now);

    usageMonitor.sendLog(buildUsageMonitorLog(func)).catch((usageMonitorError) => {
      console.error("Failed to send usage monitor log:", usageMonitorError);
    });
  }

  return {
    logFunctionUsage,
  };
}
